<template>
  <header class="userHeader">
    <v-container>
      <v-layout row wrap align-center class="userInfo">
        <div class="userAvatar">
          <img :src="userAvatar" alt="" />
        </div>
        <div class="userName">
          <template v-if="user.name">{{ user.name }}</template>
          <template v-else
            >匿名ユーザー</template
          >
          <v-menu v-if="isMypage" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" flat>
                <i class="material-icons">arrow_drop_down</i>
              </v-btn>
            </template>
            <v-list class="userOptions">
              <!-- <v-list-tile :key="1" href="/mypage" class="user-header-link"><i class="material-icons">settings</i> アカウント設定</v-list-tile> -->
              <v-list-tile :key="2" href="/logout" class="user-header-link"
                ><i class="material-icons">exit_to_app</i>
                ログアウト</v-list-tile
              >
            </v-list>
          </v-menu>
        </div>
        <div class="userAccountBtn">
          <a href="/mypage">アカウント設定</a>
        </div>
      </v-layout>

      <v-layout v-if="user.profile">
        <v-flex xs12>
          <div class="userProfile" v-text="user.profile"></div>
        </v-flex>
      </v-layout>

      <nav v-if="isPremium" class="userHeaderNav">
        <ul>
          <li :class="{ active: active == 'picks' }">
            <a :href="'/users/' + user.id">MyLibrary</a>
          </li>
          <li class="orderSwitch" v-if="active == 'picks'">
            <a
              :class="{ activeOrder: currentOrder === 'DESC' }"
              :href="'/users/' + user.id + '?order=desc'"
              >新しい順</a
            >
            <a
              :class="{ activeOrder: currentOrder === 'ASC' }"
              :href="'/users/' + user.id + '?order=asc'"
              >古い順</a
            >
          </li>
        </ul>
      </nav>
    </v-container>
  </header>
</template>

<script>
export default {
  props: [
    "user",
    "active",
    "userAvatar",
    "isMypage",
    "isFollowedByLoggedInUser",
    "isPremium",
    "order"
  ],

  data() {
    return {
      followsNum: this.user.follows_num,
      followersNum: this.user.followers_num
    };
  },
  computed: {
    currentOrder() {
      const o = (this.order || "DESC").toUpperCase();
      return o;
    }
  },
  methods: {
    setFollowersNum(followersNum) {
      this.followersNum = followersNum;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/variables";

.user {
  &Info {
    padding-bottom: 10px !important;
  }
  &Name {
    margin-right: 15px;
  }
}

.userHeader .user-header-link a {
  font-size: 1rem;
}

// Medium ~
@media (min-width: 751px) {
  .user {
    &Header {
      background: white;
      &Nav {
        border-top: 1px solid cBaseDk(10);
        ul {
          list-style-type: none;
          display: flex;
          padding-left: 0;
          li {
            a {
              @include centerXY;
              height: 50px;
              padding: 0 30px;
              color: $cText;
              border-bottom: 3px solid white;
              &:hover {
                opacity: 1;
                color: $cKey;
                border-bottom: 3px solid $cKey;
              }
            }
            &.active {
              a {
                border-bottom: 3px solid $cKey;
              }
            }
          }
        }
      }
    }
    &Info {
      padding: 30px 0;
    }
    &Avatar {
      overflow: hidden;
      width: 60px;
      height: 60px;
      padding: 0 !important;
      margin-right: 20px;
      border-radius: 999px;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
    &Profile {
      white-space: pre-wrap;
      padding-bottom: 20px;
      font-size: 1.1rem;
    }
    &Name {
      font-weight: 400;
      .v-btn {
        min-width: 36px;
        margin: 0;
        padding: 0;
      }
      .v-list {
        i {
          margin-right: 8px;
          font-size: 1.5rem;
        }
      }
    }
  }
}
// Small
@media screen and (max-width: 750px) {
  .user {
    &Info {
      padding-top: 20px !important;
    }
    &Header {
      background: white;
      &Nav {
        border-top: 1px solid cBaseDk(10);
        ul {
          list-style-type: none;
          display: flex;
          padding-left: 0;
          li {
            a {
              @include centerXY;
              height: 50px;
              padding: 0 15px;
              font-size: 0.9rem;
              color: $cText;
              border-bottom: 3px solid white;
              &:hover {
                opacity: 1;
                color: $cKey;
                border-bottom: 3px solid $cKey;
              }
            }
            &.active {
              a {
                border-bottom: 3px solid $cKey;
              }
            }
          }
        }
      }
    }
    &Info {
      padding: 30px;
    }
    &Avatar {
      overflow: hidden;
      padding: 0 !important;
      margin-right: 10px;
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
    &Profile {
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 20px;
      font-size: 1.1rem;
    }
    &Name {
      font-weight: 400;
      .v-btn {
        min-width: 36px;
        margin: 0;
        padding: 0;
      }
    }
  }
}
// Medium
@media (min-width: 751px) and (max-width: 1024px) {
  .user {
    &Header {
    }
    &Info {
      padding: 30px;
    }
  }
}
.orderSwitch {
  margin-left: auto; // 右寄せにしたい場合
  display: flex;
  gap: 10px;

  a {
    padding: 0 12px;
  }

  .activeOrder {
    color: $cKey;
    font-weight: bold;
    border-bottom: 3px solid $cKey;
  }
}
</style>
